import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form';

import { init } from './identificadorTelegramActions';
import LabelAndInput from '../common/form/labelAndInput';
import Button from '../common/form/button';

class IdentificadorTelegramForm extends Component {
    render() {
        const { handleSubmit, readOnly } = this.props;
 
        return (
            <form onSubmit={handleSubmit} autocomplete="off">
                <div className='box-body'>
                    <Field name='id_chat' component={LabelAndInput} maxLength={20} readOnly={readOnly}
                        label='ID Chat' cols='12' placeholder='Informe o ID do chat' />
                    <Field name='descricao' component={LabelAndInput} maxLength={60}
                        label='Descrição' cols='12' placeholder='Informe a descrição' />
                </div>
                <div className='box-footer'>
                    <Button type='submit' className={this.props.submitClass} icon='check' label={this.props.submitLabel} />
                    <Button type='button' className='default' icon='close' label='Cancelar' onClick={this.props.init} />
                </div>
            </form>
        )
    }
}

IdentificadorTelegramForm = reduxForm({ form: 'identificadorTelegramForm', destroyOnUnmount: false })(IdentificadorTelegramForm);
const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch);
export default connect(null, mapDispatchToProps)(IdentificadorTelegramForm);